/**
 * Ausklapp-Funktion für Suche im Header
 */
class HeaderSearchToggle {
    constructor(toggleButton) {
        toggleButton.addEventListener('click', (event) => {
            HeaderSearchToggle.toggleHeaderSearch(event);
        });
    }

    static toggleHeaderSearch(event) {
        event.preventDefault();

        const body = document.querySelector('body');
        const headersearch = document.querySelector('.js-header-search');

        headersearch.classList.toggle('is-open');
        body.classList.toggle('is-open-header-search');

        if (body.classList.contains('is-open-header-search')) {
            setTimeout(() => {
                document.querySelector('.search--header .js-search-input').focus();
            }, 0);
        }
    }
}

const headerSearchToggle = {
    init() {
        const toggleButtons = document.querySelectorAll('.js-header-search-toggle');

        if (toggleButtons) {
            toggleButtons.forEach((toggleButton) => {
                // eslint-disable-next-line no-new
                new HeaderSearchToggle(toggleButton);
            });
        }
    },
};

export default headerSearchToggle;
